import { storeRoute, storeDetailRoute } from './store';

export const allStoreRoutes = [storeRoute(), storeDetailRoute()];
